import React, { useCallback, useState } from "react";
import styles from "./VisitReservation.module.scss";
import { useModal } from "../../../context/Modal/ModalContext";
import CommonInput from "../../../components/common/inputs/CommonInput/CommonInput";
import CommonButton from "../../../components/common/buttons/CommonButton/CommonButton";
import CheckboxGroup from "../../../components/common/inputs/CheckboxGroup/CheckboxGroup";
import CommonCheckbox from "../../../components/common/inputs/CommonCheckbox/CommonCheckbox";
import axios from "axios";
// import "./custom-datepicker-style.css";

const DEFAULT_FORM_DATA = {
  company: "",
  tel: "",
  email: "",
  summary: "",
};

const VisitReservation = () => {
  const { openModal } = useModal();
  const [agree, setAgree] = React.useState([""]);
  const [isError, setIsError] = useState(false);
  const [isTelError, setIsTelError] = useState(false);
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);

  const showAlert = useCallback(
    (title) => {
      openModal({
        type: "AlertModal",
        props: {
          title,
        },
      });
    },
    [openModal]
  );

  // console.log("BASE_URL:", import.meta.env.VITE_BASE_URL);

  const handleSubmit = useCallback(
    async (company, tel, email, summary, agree) => {
      // eslint-disable-next-line no-useless-escape
      const emailPattern =
        /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
      // 연락처: 010/011/016/017/018/019 또는 02/031 등 지역번호, 숫자 9~11자리
      const telPattern = /^0[0-9]{8,10}$/;
      if (!company || !tel || !email || !summary) {
        showAlert("정보란에 모두 입력해주시길바랍니다.");
        return;
      } else if (!telPattern.test(tel.replace(/[^0-9]/g, ""))) {
        showAlert("연락처 형식을 확인해주시길 바랍니다. (예: 01012345678)");
        return;
      } else if (!emailPattern.test(email)) {
        showAlert("이메일양식을확인해주시길바랍니다.");
        return;
      } else if (agree[1] !== "agree") {
        showAlert("개인정보 수집 동의함에 체크바랍니다.");
        return;
      }

      try {
        const result = await axios.post(
          import.meta.env.VITE_BASE_URL + "/reservation",
          {
            company,
            tel,
            email,
            summary,
          },
          { withCredentials: true }
        );

        if (result?.data?.success) {
          showAlert("방문 예약 신청이 완료되었습니다.");
          setFormData(DEFAULT_FORM_DATA);
          setAgree([""]);
        } else {
          showAlert("예약 처리 중 문제가 발생했습니다. 다시 시도해주세요.");
        }
      } catch (error) {
        console.log(error);

        if (!error.response) {
          showAlert("서버에 연결할 수 없습니다. 관리자에게 문의주세요.");
          return;
        }

        if (error?.response?.status === 401) {
          const message = error?.response?.data?.message;
          switch (message) {
            case "Parameter does not exist":
              showAlert("정보란에 모두 입력해주시길바랍니다.");
              break;

            case "data format error":
              showAlert("등록할수없는 정보입니다.");
              break;

            default:
              showAlert("인증 오류가 발생했습니다. 다시 시도해주세요.");
              break;
          }
        } else {
          showAlert("등록 중 문제가 발생했습니다. 다시 시도해주세요.");
        }
      }
    },
    [showAlert]
  );

  return (
    <form className={styles.container}>
      <div className={styles.container__inputBox}>
        <CommonInput
          label="이름 / 회사명"
          placeholder="이름 / 회사명"
          hasMarginBottom
          marginright="large"
          value={formData.company}
          setFormData={setFormData}
          maxLength={20}
          name="company"
        />
        <CommonInput
          label="연락처"
          placeholder="01012345678"
          hasMarginBottom
          value={formData.tel}
          setFormData={setFormData}
          maxLength={12}
          name="tel"
          errorText="연락처 형식이 올바르지 않습니다. (예: 01012345678)"
          isError={isTelError}
          setIsError={setIsTelError}
        />
      </div>
      <div className={styles.container__inputBox}>
        <CommonInput
          label="이메일"
          value={formData.email}
          setFormData={setFormData}
          name="email"
          placeholder="smartnwork@smartwork.kr"
          hasMarginBottom
          errorText="입력값이 양식에 맞지 않습니다."
          isError={isError}
          setIsError={setIsError}
          maxLength={30}
        />
      </div>
      <CommonInput
        style={{ width: "100%" }}
        displayMultiInput
        hasMarginBottom
        label="상세 문의 내용"
        name="summary"
        value={formData.summary}
        setFormData={setFormData}
      />
      <div className={styles.container__agreeBox}>
        <CheckboxGroup values={agree} onChange={setAgree}>
          <CommonCheckbox value="agree">
            개인정보 수집 및 이용에 동의합니다.
          </CommonCheckbox>
        </CheckboxGroup>
        <CommonButton
          color="black"
          style={{
            width: "5.1rem",
            height: "2rem",
            fontSize: "10px",
            borderRadius: "2px",
            marginLeft: "8px",
          }}
          onClick={() => {
            openModal({
              type: "TermsPrivacyModal",
              props: {},
            });
          }}
        >
          내용보기
        </CommonButton>
      </div>
      <div className={styles.container__buttonBox}>
        <CommonButton
          color="black"
          style={{ width: "20rem" }}
          onClick={() =>
            handleSubmit(
              formData.company,
              formData.tel,
              formData.email,
              formData.summary,
              agree
            )
          }
        >
          문의접수
        </CommonButton>
        <a
          href={import.meta.env.VITE_NAVER_BOOKING_URL || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.naverButton}
        >
          <span className={styles.naverButton__logo}>N</span>
          네이버로 방문예약
        </a>
      </div>
    </form>
  );
};

export default VisitReservation;
